import React from 'react'
import { ConfigProvider } from 'antd'
import { IntlProvider } from 'react-intl'
import { connect } from 'react-redux'
import moment from 'moment'
import { getLocaleData } from 'locales/utils'

const Localization = ({ children, settings: { locale } }) => {
  const currentLocale = getLocaleData(locale).locales;
  moment.locale(locale);

  return (
    <ConfigProvider locale={currentLocale.antdData}>
      <IntlProvider locale={currentLocale.locale} messages={currentLocale.messages}>
        {children}
      </IntlProvider>
    </ConfigProvider>
  )
}

export default connect(({ settings }) => ({ settings }))(Localization)
